import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ProductType } from '@grandvisionhq/frk-routing';

const defaultProductKey = ProductType.Sunglasses;
const getProductKeyFromCTType = (productType)=>{
    if (CommerceToolsApi.isSunglasses(productType)) {
        return ProductType.Sunglasses;
    } else if (CommerceToolsApi.isFrames(productType)) {
        return ProductType.Frames;
    } else if (CommerceToolsApi.isAccessories(productType)) {
        return ProductType.Accessories;
    } else if (CommerceToolsApi.isSolutions(productType)) {
        return ProductType.Solutions;
    } else if (CommerceToolsApi.isLenses(productType)) {
        return ProductType.ContactLenses;
    } else if (CommerceToolsApi.isReadyReaders(productType)) {
        return ProductType.ReadyReaders;
    }
    return defaultProductKey;
};

export { getProductKeyFromCTType };
//# sourceMappingURL=get-product-key-from-ct-type.js.map
